import styles from './submit.module.css';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useEffect } from 'react';
const Submit = () => {
  useEffect(() => {
    ScrollTrigger.create({
      trigger: `.${styles.svg}`,
      start: 'top 75%',
      onEnter: () => {
        document.querySelector(`.${styles.svg}`).classList.add("active")
    }
    });

    window.addEventListener("load", () => {
        ScrollTrigger.refresh()
    } );
  });
  return (
    <svg
      width="112"
      height="112"
      viewBox="0 0 112 112"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={styles.svg}
    >
      <g className={styles.link}>
        <path
          d="M55.8138 62.364L59.3493 58.8284C60.9114 57.2663 63.4441 57.2663 65.0062 58.8284V58.8284C66.5683 60.3905 66.5683 62.9232 65.0062 64.4853L60.0564 69.435C58.8848 70.6066 56.9853 70.6066 55.8138 69.435L55.1067 68.7279"
          stroke="#F8F6EC"
          strokeLinecap="round"
        />
        <path
          d="M56.5207 72.9705L52.9852 76.506C51.4231 78.0681 48.8904 78.0681 47.3283 76.506V76.506C45.7662 74.9439 45.7662 72.4113 47.3283 70.8492L52.2781 65.8994C53.4496 64.7279 55.3491 64.7279 56.5207 65.8994L57.2278 66.6066"
          stroke="#F8F6EC"
          strokeLinecap="round"
        />
      </g>

      <path
        d="M15.5 52.5H95.5M15.5 52.5V102.5M15.5 52.5L42.8218 85.3418M95.5 52.5V102.5M95.5 52.5L68.2328 85.3418M95.5 102.5V108.5H15.5V102.5M95.5 102.5L74 88.5C72.0728 87.253 70.1512 86.2001 68.2328 85.3418M15.5 102.5L37 88.5C38.9487 87.2528 40.8885 86.2001 42.8218 85.3418M42.8218 85.3418C51.3565 81.5526 59.7627 81.5525 68.2328 85.3418"
        stroke="#F8F6EC"
        strokeLinejoin="round"
      />
      <path
        d="M15.5 52.5H95.5L55.5 4.5L15.5 52.5Z"
        fill="#070707"
        stroke="#F8F6EC"
        strokeLinejoin="round"
        className={styles.path1}
      />
    </svg>
  );
};

export default Submit;
